import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback, useState } from 'react';
import { AttributeList } from '../attribute-list';
import { Button } from '../button/button';
import { ButtonColor } from '../button/types/color';
import { Heading, HeadingLevel } from '../heading/heading';
import { AttributeLegendModal } from './subcomponents/modal';
const b = bemClassBuilder('v-attribute-legend');
export const AttributeLegend = observer(props => {
    const { heading, attributes, viewLegendButtonLabel, modalHelpText, iconCdnOptions, showLabel } = props;
    const [showLegendModal, setShowLegendModal] = useState(false);
    const handleLegendModalOpen = useCallback(() => {
        setShowLegendModal(true);
    }, []);
    const handleLegendModalClose = useCallback(() => {
        setShowLegendModal(false);
    }, []);
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [showLabel && (_jsx(Heading, Object.assign({ level: HeadingLevel.H5, className: b.element('heading') }, { children: heading }))), _jsx(AttributeList, { attributes: attributes, showDetails: false, iconCdnOptions: iconCdnOptions }), _jsx(Button, { className: b.element('view-button'), label: viewLegendButtonLabel, color: ButtonColor.Tertiary, onClick: handleLegendModalOpen }), _jsx(AttributeLegendModal, { show: showLegendModal, attributes: attributes, heading: heading, onClose: handleLegendModalClose, helpText: modalHelpText, iconCdnOptions: iconCdnOptions })] })));
});
AttributeLegend.displayName = 'AttributeLegend';
